import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import UpsellForm from "../forms/upsellForm";
import {upsellService} from "../../services";

const freshData = (order) => {
    return {
        name: null,
        description: null,
        landingPageUrl: null,
        price: null,
        order: order,
        valid: false,
    }
};

const AddUpsellDialog = (props) => {
    const {snackbar, order, onCancel, onSave} = props;
    const [data, setData] = useState(freshData(order));
    const [saving, setSaving] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(saved.name + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const upsell = {
            name: data.name,
            description: data.description,
            landingPageUrl: data.landingPageUrl,
            price: data.price,
            order: data.order,
        };

        upsellService.createUpsell(upsell, success, failure);
    };

    return <Dialog
        open={true}
        aria-labelledby="add-upsell-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Upsell
        </ClosableDialogTitle>
        <DialogContent className="add-upsell-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <UpsellForm
                    data={data}
                    onChange={setData}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button
                color="primary"
                disabled={!data.valid}
                onClick={submitForm}
            >
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default AddUpsellDialog;
